export enum ManagamentType {
  Full = 0,
  RentCollect = 1,
  LetOnly = 2,
}
